/**
 * Lista de especialidades comuns para sugestão no cadastro de profissionais
 * Inclui especialidades médicas, de saúde e outras áreas
 */
export const COMMON_SPECIALTIES = [
    // Especialidades Médicas
    'Acupuntura',
    'Alergia e Imunologia',
    'Anestesiologia',
    'Angiologia',
    'Cardiologia',
    'Cirurgia Cardiovascular',
    'Cirurgia da Mão',
    'Cirurgia de Cabeça e Pescoço',
    'Cirurgia do Aparelho Digestivo',
    'Cirurgia Geral',
    'Cirurgia Oncológica',
    'Cirurgia Pediátrica',
    'Cirurgia Plástica',
    'Cirurgia Torácica',
    'Cirurgia Vascular',
    'Clínica Médica',
    'Coloproctologia',
    'Dermatologia',
    'Endocrinologia e Metabologia',
    'Endoscopia',
    'Gastroenterologia',
    'Genética Médica',
    'Geriatria',
    'Ginecologia e Obstetrícia',
    'Hematologia e Hemoterapia',
    'Homeopatia',
    'Infectologia',
    'Mastologia',
    'Medicina de Emergência',
    'Medicina de Família e Comunidade',
    'Medicina do Trabalho',
    'Medicina do Tráfego',
    'Medicina Esportiva',
    'Medicina Física e Reabilitação',
    'Medicina Intensiva',
    'Medicina Legal e Perícia Médica',
    'Medicina Nuclear',
    'Medicina Preventiva e Social',
    'Nefrologia',
    'Neurocirurgia',
    'Neurologia',
    'Nutrologia',
    'Oftalmologia',
    'Oncologia Clínica',
    'Ortopedia e Traumatologia',
    'Otorrinolaringologia',
    'Patologia',
    'Patologia Clínica/Medicina Laboratorial',
    'Pediatria',
    'Pneumologia',
    'Psiquiatria',
    'Radiologia e Diagnóstico por Imagem',
    'Radioterapia',
    'Reumatologia',
    'Urologia',

    // Odontologia
    'Cirurgia e Traumatologia Buco-Maxilo-Facial',
    'Dentística',
    'Endodontia',
    'Implantodontia',
    'Odontologia Estética',
    'Odontopediatria',
    'Ortodontia',
    'Periodontia',
    'Prótese Dentária',
    'Radiologia Odontológica',

    // Enfermagem
    'Enfermagem Cirúrgica',
    'Enfermagem do Trabalho',
    'Enfermagem em Cardiologia',
    'Enfermagem em Geriatria',
    'Enfermagem em Nefrologia',
    'Enfermagem em Oncologia',
    'Enfermagem em Pediatria',
    'Enfermagem em Saúde Mental',
    'Enfermagem em UTI',
    'Enfermagem Obstétrica',

    // Psicologia
    'Neuropsicologia',
    'Psicanálise',
    'Psicologia Clínica',
    'Psicologia do Esporte',
    'Psicologia Hospitalar',
    'Psicologia Infantil',
    'Psicologia Organizacional',
    'Psicologia Social',
    'Terapia Cognitivo-Comportamental',
    'Terapia de Casal e Família',

    // Fisioterapia
    'Fisioterapia Aquática',
    'Fisioterapia Cardiorrespiratória',
    'Fisioterapia Dermatofuncional',
    'Fisioterapia do Trabalho',
    'Fisioterapia em Geriatria',
    'Fisioterapia em Oncologia',
    'Fisioterapia em Pediatria',
    'Fisioterapia Esportiva',
    'Fisioterapia Neurofuncional',
    'Fisioterapia Ortopédica',
    'Fisioterapia Pélvica',
    'Pilates',
    'RPG - Reeducação Postural Global',

    // Nutrição
    'Nutrição Clínica',
    'Nutrição Comportamental',
    'Nutrição Esportiva',
    'Nutrição Funcional',
    'Nutrição Materno-Infantil',
    'Nutrição Oncológica',

    // Fonoaudiologia
    'Audiologia',
    'Disfagia',
    'Fonoaudiologia Educacional',
    'Fonoaudiologia Hospitalar',
    'Linguagem',
    'Motricidade Orofacial',
    'Voz',

    // Terapia Ocupacional
    'Terapia Ocupacional em Geriatria',
    'Terapia Ocupacional em Neurologia',
    'Terapia Ocupacional em Pediatria',
    'Terapia Ocupacional em Saúde Mental',

    // Outras áreas de saúde
    'Aconselhamento Genético',
    'Biomedicina',
    'Educação Física',
    'Farmácia Clínica',
    'Gerontologia',
    'Musicoterapia',
    'Osteopatia',
    'Podologia',
    'Quiropraxia',
    'Serviço Social',

    // Estética e Bem-estar
    'Estética Corporal',
    'Estética Facial',
    'Massoterapia',
    'Micropigmentação',
    'Podologia Estética',

    // Veterinária
    'Anestesiologia Veterinária',
    'Cardiologia Veterinária',
    'Cirurgia Veterinária',
    'Clínica de Pequenos Animais',
    'Dermatologia Veterinária',
    'Neurologia Veterinária',
    'Odontologia Veterinária',
    'Oftalmologia Veterinária',
    'Oncologia Veterinária',
    'Ortopedia Veterinária',
]

/**
 * Filtra especialidades comuns baseado no texto digitado
 * @param searchText Texto para filtrar
 * @param excludeNames Nomes a excluir (já selecionados)
 * @param limit Limite de resultados
 * @returns Lista de especialidades filtradas
 */
export function filterCommonSpecialties(
    searchText: string,
    excludeNames: string[] = [],
    limit: number = 10
): string[] {
    const normalizedSearch = searchText.toLowerCase().trim()

    if (!normalizedSearch) {
        return []
    }

    const excludeNormalized = excludeNames.map(n => n.toLowerCase())

    return COMMON_SPECIALTIES.filter(
        specialty =>
            specialty.toLowerCase().includes(normalizedSearch) &&
            !excludeNormalized.includes(specialty.toLowerCase())
    ).slice(0, limit)
}
